import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getDocEditorServiceEndPoint } from "./base-url/api-constants";
import { getAuthHeader } from "../utils/helper";
import { getMusicGenerationApiUrl, getStemSeparationApiUrl } from "../utils/musicGenerationApi";
import type { DocEditorResponse } from "../types/DocEditorResponse";

class DocEditorService {
  DocEditorService(url: string) {
    return getDocEditorServiceEndPoint(url);
  }

  GetEditorQueryInfo(id: string) {
    const apiEndpoint = this.DocEditorService(
      `${endPoints.docEditorService.EDITOR_INFO.replace(":id", id)}`
    );

    return apiService.get(apiEndpoint, null, getAuthHeader());
  }

  /** `silent` suppresses the global error popup for fire-and-forget tracking. */
  TrackEvent(data: unknown, silent = false) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.TRACK_EVENT}`);

    return apiService.post(apiEndpoint, data, getAuthHeader(), {
      silentError: silent,
    });
  }

  SaveEditorQueryInfo(data: any) {
    const apiEndpoint = this.DocEditorService(`${endPoints.docEditorService.SAVE_EDITOR_INFO}`);

    return apiService.post(apiEndpoint, data, getAuthHeader());
  }
  MusicGeneration(data: Record<string, unknown>): Promise<DocEditorResponse> {
    const apiEndpoint = getMusicGenerationApiUrl();
    return apiService.post<DocEditorResponse>(apiEndpoint, data, getAuthHeader());
  }

  StemSeparation(data: Record<string, unknown>): Promise<DocEditorResponse> {
    const apiEndpoint = getStemSeparationApiUrl();
    return apiService.post<DocEditorResponse>(apiEndpoint, data, getAuthHeader());
  }
}

export default new DocEditorService();
